export type StatusTone = 'success' | 'warn' | 'danger' | 'neutral' | 'info';

const TONES: Record<StatusTone, { dot: string; bg: string; text: string }> = {
	success: {
		dot: 'var(--color-status-success)',
		bg: 'var(--color-status-success-soft)',
		text: 'var(--color-status-success)',
	},
	warn: {
		dot: 'var(--color-status-warn)',
		bg: 'var(--color-status-warn-soft)',
		text: 'var(--color-status-warn)',
	},
	danger: {
		dot: 'var(--color-status-danger)',
		bg: 'var(--color-status-danger-soft)',
		text: 'var(--color-status-danger)',
	},
	info: {
		dot: 'var(--color-status-info)',
		bg: 'var(--color-status-info-soft)',
		text: 'var(--color-status-info)',
	},
	neutral: {
		dot: 'var(--color-status-neutral)',
		bg: 'var(--color-status-neutral-soft)',
		text: 'var(--color-text-3)',
	},
};

export function StatusBadge({
	active,
	activeLabel = 'Active',
	inactiveLabel = 'Inactive',
	activeTone = 'success',
	inactiveTone = 'neutral',
}: {
	active: boolean;
	activeLabel?: string;
	inactiveLabel?: string;
	activeTone?: StatusTone;
	inactiveTone?: StatusTone;
}) {
	const tone = TONES[active ? activeTone : inactiveTone];
	return (
		<span
			className="inline-flex items-center gap-1.5 rounded-[var(--r-1)] px-2 py-1 text-xs leading-none font-medium"
			style={{ background: tone.bg, color: tone.text }}
		>
			<span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: tone.dot }} />
			{active ? activeLabel : inactiveLabel}
		</span>
	);
}
